import React, { useState, useEffect } from "react";
import axios from "axios";
import { Loading } from 'react-simple-chatbot';
import { API_URL } from '../constant'

const FetchAnswer = ({ steps, triggerNextStep }) => {
  const [loading, setLoading] = useState(true);
  const [response, setResponse] = useState("");
  const [isErrror, setIsError] = useState(false);

  const searchApi = async() => {
    const profileValue =  steps.optionsProfile.value;
    const profile = profileValue === 'custom' ? steps.userInputProfile.value : profileValue;
    const userQuestion = steps.userInputQuestion.value;

    setIsError(false)
    setLoading(true);
    try {
     const {data} = await axios.get(API_URL, {
        params: {
          question: `Sobre el siguiente perfil: ${profile}. ${userQuestion}`
        }
      })
      setResponse(data.data);
      setLoading(false);
      setTimeout(() => triggerNextStep(), 1000);
    } catch (error) {
      setIsError(true)
      setLoading(false);
    }
  }

  useEffect(() => {
    searchApi()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (<div>
    {loading ? <Loading/> : response}
    {!loading && isErrror && 
      <div className="error-response">
        <div>Falló la solicitud</div>
        <button onClick={() => searchApi()}>Reintentar</button>
      </div>
    }
  </div>);
};

export default FetchAnswer
